<div class="grid-container padding-y-4">
    <form [formGroup]="hhgCsvDownloadForm">
        <div class="grid-row grid-gap-1">
            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
                <legend class="usa-legend usa-legend--large">FRT Rates Download to CSV file</legend>
            </div>
        </div>
        <div class="grid-row grid-gap-1">
            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
                <label for="effective_dates" class="usa-label">Rate Effective Dates<abbr title="required"
                        class="usa-hint usa-hint--required">*</abbr></label>
                <select id="effective_dates" class="maxw-full usa-select" formControlName="effectiveDates" (change)="effectiveDatesChange($event.target.value)" required>
                    <option value='' selected disabled>Choose...</option>
                    <option *ngFor="let rateBidCycle of ratesBidcyclesList" [value]="rateBidCycle.ratesBidcyclesId">
                        {{rateBidCycle.bidCycleName}} ( {{rateBidCycle.rateEffectiveDate | date:'mediumDate':'UTC'}} -
                        {{rateBidCycle.rateExpiryDate | date:'mediumDate':'UTC'}} )
                    </option>
                </select>
            </div>
        </div>
        <div class="grid-row grid-gap-1">
            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
                <label for="scac" class="usa-label">SCAC<abbr title="required"
                    class="usa-hint usa-hint--required">*</abbr></label>
                <select id="scac" class="maw-full usa-select define-height-usa-select" formControlName="scac" size="10" multiple data-max-options="10" (change)="scacChange($event.target.value)" required>
                    <option value='' selected disabled>Choose...</option>                                
                    <option *ngFor="let carrier of carrierList" [value]="carrier.carrierId">{{carrier.scac}} - {{carrier.scacName}}</option>                      
                </select>
            </div>
            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
                <label for="sro" class="usa-label">SRO<abbr title="required"
                    class="usa-hint usa-hint--required">*</abbr></label>
                <select multiple id="sro" class="usa-select maxw-full define-height-usa-select" formControlName="sro" size="10" (change)="sroChange($event.target.value)" required>
                    <option value='' selected disabled>Choose...</option> 
                    <option *ngFor="let sro of sroList" [value]="sro.sroMasterId">
                    {{sro.sroId}}
                    </option>                   
                </select>
            </div>
        </div>
        <div class="grid-row grid-gap-1">
            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
                <label for="origin" class="usa-label">Origin<abbr title="required"
                    class="usa-hint usa-hint--required">*</abbr></label>
                <select id="origin" class="maxw-full usa-select" formControlName="origin" (change)="originChange($event.target.value)" required>
                    <option value='' selected disabled>Choose...</option>
                    <option value='0'>All Origins</option> 
                    <option *ngFor="let state of origStateList" [value]="state.stateCountryId">
                    {{state.stateCountryName}} - {{state.stateCountryCode}}</option>
                </select>
            </div>
            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
                <label for="destination" class="usa-label">Destination<abbr title="required"
                    class="usa-hint usa-hint--required">*</abbr></label>
                <select id="destination" class="usa-select maxw-full" formControlName="destination" (change)="destinationChange($event.target.value)" required>
                    <option value='' selected disabled>Choose...</option>
                    <option value='0' >All Destinations</option> 
                    <option *ngFor="let state of destStateList" [value]="state.stateCountryId">
                    {{state.stateCountryName}} - {{state.stateCountryCode}}</option>                    
                </select>
            </div>
        </div>
        <div class="padding-top-2">
            <button class="usa-button" [disabled]="!(controlChanged && scacChanged && sroChanged && originChanged && destinationChanged)" (click)="download()">Download</button>
        </div>
    </form>
</div>